import { createContext } from 'react';

export const IsMobileContext = createContext(false);
export const DataSourceContext = createContext(null);